/** Kurirski nalozi grupisani po trgovini, redoslijedom kojim ih server već sortira.
 *  Nalog bez trgovine ide pod prazan ključ. */
export function groupByStore<T extends { storeName?: string | null }>(credentials: T[]): [string, T[]][] {
  const groups = new Map<string, T[]>();
  for (const c of credentials) {
    const key = c.storeName ?? "";
    const group = groups.get(key);
    if (group) group.push(c); else groups.set(key, [c]);
  }
  return [...groups.entries()];
}
